// extracted by mini-css-extract-plugin
export var blogDate = "blogCategoryButton-module--blogDate--adf64";
export var categoryLink = "blogCategoryButton-module--categoryLink--9a333";
export var detailsRow = "blogCategoryButton-module--detailsRow--3815a";
export var light = "blogCategoryButton-module--light--77c49";